import { Lookup } from "./lookup.models";
import { TableColumnMetaData } from "./table-column-metadata";
import { PermissionModel } from "../manage/permissions.models";

export class TableMetaData {
    id: number;
    lookupId: number;
    tableName: string;
    tableDisplayName: string;
    lookup: Lookup;
    sortAlphabetical: boolean;
    isForAdmin: number;
    hierarchicalMaxNumberOfLevels: number;
    enforceReferentialIntegrityConstraint: number;
    permissionId: number;
    isOpen?: boolean;
    tableColumnMetadatas: TableColumnMetaData[];
    getPermission: PermissionModel;
    addPermission: PermissionModel;
    updatePermission: PermissionModel;
    deletePermission: PermissionModel;
}